module.exports = __webpack_public_path__ + "static/media/banner_02.3286d596.png";